import {
  IEvent, WorkflowStatus,
  WorkflowStatusClass,
  WorkflowStatusText,
} from '../../store/events/interfaces'
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

export const WorkflowStatusBadge = (props: { event: IEvent }) => {
  const { event } = props
  const { testMode } = useSelector((state: RootState) => state.institution)
  const { data: program } = useSelector((state: RootState) => state.program)
  const className = WorkflowStatusClass[event.workflow_status]
  const text = WorkflowStatusText[event.workflow_status]


  return (
    <>
      {program.use_workflow && event.workflow_status && testMode && (
        <OverlayTrigger
          placement='auto'
          overlay={
                <Tooltip id={`${event.id}-workflow-info`}>
                  {event.workflow_status === WorkflowStatus.INSTITUTION_OK ?
                    "Diese Veranstaltung ist im Moment für Teilnehmer sichtbar." :
                    "Diese Veranstaltung ist für Teilnehmer im Moment nicht sichtbar."}
                </Tooltip>
            }
          trigger={['hover', 'focus']}
        >
          <Badge className={`badge-pill ${className} ml-1`}>{text}</Badge>
        </OverlayTrigger>
      )}
    </>
  )
}
